// src/components/StoreRequestPopup.jsx
import React, { useState } from 'react';
import './StoreRequestPopup.css';

// TODO: placeholder — replace once you have your real Calendly event link
// (e.g. https://calendly.com/your-username/intro-call)
const CALENDLY_URL = 'https://calendly.com/REPLACE_WITH_REAL_LINK';

const StoreRequestPopup = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    full_name: '',
    store_name: '',
    domain_name: '',
    owner_address: '',
    owner_phone: ''
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('https://creativepulse.pk/main-api/store-request.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (data.success) {
        setSubmitted(true);
        setTimeout(() => {
          window.location.href = CALENDLY_URL;
        }, 2000);
      } else {
        setError(data.message || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting request:', error);
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-container" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close" onClick={onClose}>×</button>

        {!submitted ? (
          <>
            <div className="popup-header">
              <h2>Create Your Store</h2>
              <p>Fill out the form below to request your online store</p>
            </div>

            <form onSubmit={handleSubmit} className="popup-form">
              <div className="form-group">
                <label>Full Name *</label>
                <input
                  type="text"
                  name="full_name"
                  value={formData.full_name}
                  onChange={handleChange}
                  required
                  placeholder="Enter your full name"
                />
              </div>

              <div className="form-group">
                <label>Store Name *</label>
                <input
                  type="text"
                  name="store_name"
                  value={formData.store_name}
                  onChange={handleChange}
                  required
                  placeholder="Enter your store name"
                />
              </div>

              <div className="form-group">
                <label>Domain Name *</label>
                <input
                  type="text"
                  name="domain_name"
                  value={formData.domain_name}
                  onChange={handleChange}
                  required
                  placeholder="yourstore.com"
                />
                <small>Enter your desired domain name (e.g., mystore.com)</small>
              </div>

              <div className="form-group">
                <label>Owner Address *</label>
                <textarea
                  name="owner_address"
                  value={formData.owner_address}
                  onChange={handleChange}
                  required
                  rows="3"
                  placeholder="Enter your complete address"
                />
              </div>

              <div className="form-group">
                <label>Phone Number *</label>
                <input
                  type="tel"
                  name="owner_phone"
                  value={formData.owner_phone}
                  onChange={handleChange}
                  required
                  placeholder="+1 234 567 8900"
                />
              </div>

              {error && <div className="error-message">{error}</div>}

              <button type="submit" disabled={loading} className="submit-btn">
                {loading ? 'Submitting...' : 'Create Store'}
              </button>
            </form>
          </>
        ) : (
          <div className="success-message">
            <div className="success-icon">✓</div>
            <h3>Request Submitted Successfully!</h3>
            <p>Redirecting you to book a call with our team...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default StoreRequestPopup;